module.exports = __webpack_public_path__ + "static/media/TRI.282058d6.png";